import React from 'react'
import { PasswordInput, type PasswordInputProps } from '@mantine/core'

export type AppPasswordInputProps = PasswordInputProps

export default function AppPasswordInput (props: AppPasswordInputProps) {
  return <PasswordInput radius="sm" {...props} />
}
